type Props = {
  name: string
  /**
   * 幅に収まらない場合に 1 行省略（…）する。
   * flex アイテムを内容幅より縮めるため min-w-0 が必要。
   * 省略で読めなくなる分は title 属性で補う。
   */
  truncate?: boolean
}

export const SheetName = ({ name, truncate = false }: Props) => {
  return (
    <span
      className={`rounded-[8px] border border-[#cbcbce] px-2 py-0.5 text-[12px] font-bold leading-[16px] text-black${truncate ? ' min-w-0 truncate' : ''}`}
      title={truncate ? name : undefined}
    >
      {name}
    </span>
  )
}
